import React from "react";
import "../css/subscribe.css";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import productData from "../Datas/productData";

const SubscriptionPage = () => {
  const navigate = useNavigate();

  const toCheck = (sub) => {
    navigate("/checkout", { state: { sub } });
  };

  const subscriptionPlans = productData.filter((p) => p.includes);

  return (
    <>
      <Header />
      <main className="subscription-main">
        <div className="subscription-container">
          <div className="subscription-header">
            <h1>Subscriptions</h1>
            <p>
              Join the club. Get exclusive access and curated goods delivered to
              your door.
            </p>
          </div>
          <div className="subscription-plans">
            {subscriptionPlans.map((sub, index) => (
              <div
                key={index}
                className={`subscription-plan ${
                  index === 1 ? "is-featured" : ""
                }`}
              >
                {index === 1 && (
                  <div className="featured-badge">Most Popular</div>
                )}
                <div className="plan-content">
                  <h2 className="plan-name">{sub.name}</h2>
                  <div className="plan-price">
                    <span className="price-amount">${sub.price}</span>
                    <span className="price-term">/ day</span>
                  </div>
                  <ul className="plan-includes-list">
                    {sub.includes.map((include, i) => (
                      <li key={i} className="include-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-check"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <span>{include}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    className="subscribe-btn"
                    onClick={() => toCheck(sub)}
                  >
                    Choose Plan
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SubscriptionPage;
